import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import why_1 from '../../../assets/images/why-choose/why-choose-image-1.jpg';
import why_2 from '../../../assets/images/play-icon.svg';
import why_3 from '../../../assets/images/svg/counter-1.svg';
import why_4 from '../../../assets/images/svg/counter-2.svg';
import why_5 from '../../../assets/images/svg/counter-3.svg';
import why_6 from '../../../assets/images/svg/counter-4.svg';

const WhyChouse = () => {
    const [ytshow, setytshow] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(`.counter-one`);

            elements.forEach((element) => {
                const position = element.getBoundingClientRect().top + window.scrollY;
                const windowHeight = window.innerHeight;
                const scrollTop = window.scrollY;

                if (position <= scrollTop + windowHeight && position + element.offsetHeight >= scrollTop) {
                    element.querySelectorAll("svg").forEach((svg) => {
                        svg.classList.add("animated-svg");
                    });
                    element
                        .querySelectorAll(".counter-box-one")
                        .forEach((el) => {
                            el.classList.add("active");
                        });
                } else {
                    element.querySelectorAll("svg").forEach((svg) => {
                        svg.classList.remove("animated-svg");
                    });
                    element
                        .querySelectorAll(".service-left-details-one, .about-details-one, .work-details-one")
                        .forEach((el) => {
                            el.classList.remove("active");
                        });
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    return (
        <>
            <div className="why-choose-section-one">
                <div className="why-choose-background-one">
                    <div className="why-choose-background-image-one">
                        <img src={why_1} alt="why-choose-image" />
                    </div>
                </div>
                <div className="video-play-one">
                    <p>
                        Why clients <br /> choose us
                    </p>
                    <button onClick={() => setytshow(true)} style={{ background: "none", border: "none" }}>
                        <img src={why_2} alt="icon" />
                    </button>
                </div>
                <div className="container">
                    <div className="counter-one">
                        <div className="counter-box-one">
                            <div className="counter-box-one-inner">
                                <div className="counter-icon">
                                    <img src={why_3} alt="icon" />
                                </div>
                                <h4>
                                    <span className="counter">
                                        <CountUp end={1962} duration={3} />
                                    </span>
                                    <span>+</span>
                                </h4>
                                <p>Companies analyzed</p>
                            </div>
                        </div>
                        <div className="counter-box-one">
                            <div className="counter-box-one-inner">
                                <div className="counter-icon">
                                    <img src={why_4} alt="icon" />
                                </div>
                                <h4>
                                    <span className="counter">
                                        <CountUp end={1856} duration={3} />
                                    </span>
                                    <span>+</span>
                                </h4>
                                <p>Strategies planned</p>
                            </div>
                        </div>
                        <div className="counter-box-one">
                            <div className="counter-box-one-inner">
                                <div className="counter-icon">
                                    <img src={why_5} alt="icon" />
                                </div>
                                <h4>
                                    <span className="counter">
                                        <CountUp end={2566} duration={3} />
                                    </span>
                                </h4>
                                <p>Projects released</p>
                            </div>
                        </div>
                        <div className="counter-box-one">
                            <div className="counter-box-one-inner">
                                <div className="counter-icon">
                                    <img src={why_6} alt="icon" />
                                </div>
                                <h4>
                                    <span className="counter">
                                        <CountUp end={1862} duration={3} />
                                    </span>
                                </h4>
                                <p>Satisfied clients</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {ytshow && (
                <div className="YouTubePopUp-Wrap"
                    tabIndex={-1}
                    style={{ display: "block", opacity: 157 }}
                    aria-modal="true">
                    <div className="YouTubePopUp-Content">
                        <span className="YouTubePopUp-Close" onClick={() => setytshow(false)} />
                        <iframe
                            width={640}
                            height={360}
                            src="https://www.youtube.com/embed/rzfmZC3kg3M?autoplay=1"
                            allowFullScreen=""
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default WhyChouse;
